import { defineModule } from '@kubdee/sdk'
import { MODULES } from '@kubdee/shared'
import { migrations } from './migrations'
import { connectorsDoctypes } from './doctypes'
import { registerFacebookMessengerAdapter } from './adapters/facebook-messenger'
import { registerFacebookPageAdapter } from './adapters/facebook-page'
import { registerLineOaAdapter } from './adapters/line-oa'
import { registerInstagramDmAdapter } from './adapters/instagram-dm'
import { registerGoogleCalendarAdapter } from './adapters/google-calendar'
import { registerGmailAdapter } from './adapters/gmail'
import { registerShopeeAdapter } from './adapters/shopee'

// Self-register the first-party Messenger adapter at module load time. Both
// the webhook ingress (#237) + capability dispatcher (#236) read from
// in-isolate registries — they stay in sync with the DB seed (migration 002)
// because every Worker isolate re-runs this line at cold-start.
registerFacebookMessengerAdapter()
// Facebook Page social-posting adapter (#788 — first social-posting
// implementer). Distinct from facebook-messenger because pages publishing
// (pages_manage_posts) and Messenger DMs (pages_messaging) require
// different Meta App Review tracks. Seed row provisioned by migration 011.
//
// IMPORTANT: this call registers WITHOUT runtime deps because this manifest is
// walked by apps/web. Backend entrypoints overwrite it via
// `services/facebook-page-runtime.ts` once Worker env is available, binding
// rate limiting + KV idempotency for real request/DO paths.
registerFacebookPageAdapter()
// Line Official Account adapter (P6 — #240). Same semantics as above; seed
// row provisioned by migration 003.
registerLineOaAdapter()
// Instagram Direct Messages adapter (P7 — #241). Uses the Meta Messaging
// Platform (same webhook HMAC as Messenger) with Instagram-specific 24h
// window + MESSAGE_TAG / HUMAN_AGENT enforcement. Seed row provisioned by
// migration 004.
registerInstagramDmAdapter()
// Google Calendar adapter (P8 — #242). Implements the `calendar` capability
// with OAuth 2.1 + PKCE auth and the Calendar Watch API for push
// notifications (shared-secret header verify, not HMAC). Seed row
// provisioned by migration 005.
registerGoogleCalendarAdapter()
// Gmail adapter (P9 — #243). Implements the `email` capability with
// OAuth 2.1 + PKCE (access_type=offline + prompt=consent) and Pub/Sub push
// webhook ingress. Seed row provisioned by migration 006.
registerGmailAdapter()
// Shopee adapter (P10 — #244). Implements the `commerce` capability with
// Shopee's partner-auth flow (NOT standard OAuth), HMAC-SHA256 request
// signing on every API call, and Push V2 webhook verification (HMAC-SHA256
// of `url|body`, base64-encoded, in the Authorization header). Seed row
// provisioned by migration 007.
registerShopeeAdapter()

const MODULE_ICON = 'Plug'
const MODULE_COLOR = '#2490EF'

export default defineModule({
  name: MODULES.CONNECTORS,
  label: 'เชื่อมต่อระบบภายนอก',
  displayName: 'Connectors',
  icon: MODULE_ICON,
  color: MODULE_COLOR,
  version: '0.1.0',
  dependencies: [MODULES.CORE],
  category: 'core',
  isSystemModule: false,

  schemas: {},
  routes: {},
  navigation: {
    label: 'เชื่อมต่อระบบ',
    icon: MODULE_ICON,
    groups: [
      {
        label: 'จัดการ',
        items: [
          { label: 'การเชื่อมต่อ', path: '/connectors', icon: MODULE_ICON, exact: true },
        ],
      },
      {
        label: 'ตั้งค่า',
        items: [
          { label: 'MCP Tokens', path: '/connectors/mcp-tokens', icon: 'KeyRound' },
          { label: 'Webhooks', path: '/connectors/webhooks', icon: 'Webhook' },
          { label: 'ตั้งค่าทั่วไป', path: '/connectors/settings', icon: 'Settings' },
        ],
      },
    ],
  },
  permissions: {},
  hooks: {},

  doctypes: [
    { key: 'types', label: 'ประเภทการเชื่อมต่อ' },
    { key: 'instances', label: 'การเชื่อมต่อที่ใช้งาน' },
    { key: 'credentials', label: 'Credentials' },
  ],
  availableHooks: [],

  extendSchemas: {},
  fixtures: [],

  moduleMigrations: migrations,

  // Doctype Catalog First (#644) - metadata-only registry rows consumed by
  // the tenant-worker boot loop. Connectors services/DOs still own writes.
  registeredDoctypes: connectorsDoctypes,
})
